export default __webpack_public_path__ + "static/media/rocket_anim_104.3de346c2.png";